import styled from 'styled-components';
import { Input as AntdInput, Select as AntdSelect } from 'antd';

export const Input = styled(AntdInput)`
  flex: 1 !important;
  font-size: 16px;
  width: 150px;
  padding: 0 4px;
`;

export const Select = styled(AntdSelect)`
  flex: 1 !important;
  font-size: 16px;
  width: 200px;
  align-self: center;
  padding: 2px 0;
  border-radius: 4px;

  .ant-select-selection-overflow-item-suffix {
    overflow: hidden;
    flex: 1;
  }
` as typeof AntdSelect;

export const EditableSelectOption = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 12px;
  cursor: initial;

  > span.anticon {
    flex: none;
    padding: 4px;
    border-radius: 4px;
    color: #8c8c8c;

    :not([disabled]) {
      cursor: pointer;

      :hover {
        color: #295cdc;
        background-color: rgb(0 0 0 / 6%);
      }
    }

    &[disabled] {
      cursor: not-allowed;
    }
  }

  > .ant-divider {
    margin: 0 2px;
  }
`;

export const EditableSelectOptionLabel = styled.div`
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-right: 4px;
`;
